<div class="payment-refund-any-amount-confirm-dialog-container" data-cy="ar-payment-refund-any-amount-confirm">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-payment-refund-any-amount-confirm-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-refund-any-amount-confirm-header">
      <div class="section-header-title" data-cy="ar-payment-refund-any-amount-confirm-title">
        Patient Payment Refund
      </div>
      <div style="flex: 1;" data-cy="ar-payment-refund-any-amount-confirm-header-spacer"></div>
    </div>

    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="ar-payment-refund-any-amount-confirm-content">

      @if (isLoading) {
        <app-tdo-progress-spinner style="flex: 1;" data-cy="ar-payment-refund-any-amount-confirm-spinner"></app-tdo-progress-spinner>
      }

      @if (!isLoading) {
        <div data-cy="ar-payment-refund-any-amount-confirm-loaded-content">
          <div style="display: flex" data-cy="ar-payment-refund-any-amount-confirm-main-container">
            <div style="flex: 1; padding-right:20px" data-cy="ar-payment-refund-any-amount-confirm-details-container">
              <div style="padding-bottom: 10px" data-cy="ar-payment-refund-any-amount-confirm-details-header"><b>Refund Details</b></div>
              <div style="display: flex" data-cy="ar-payment-refund-any-amount-confirm-account-container">
                <div style="flex-basis: 170px" data-cy="ar-payment-refund-any-amount-confirm-account-label">From Doctor Account</div>
                <div style="flex: 1" data-cy="ar-payment-refund-any-amount-confirm-account-select-container">
                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-refund-any-amount-confirm-account-field">
                    <mat-label data-cy="ar-payment-refund-any-amount-confirm-account-select-label">Payment Account</mat-label>
                    <mat-select [(ngModel)]="arAccountID" data-cy="ar-payment-refund-any-amount-confirm-account-select">
                      @for (arAccount of arAccounts; track arAccount) {
                        <mat-option [value]="arAccount.ARAccountID" data-cy="ar-payment-refund-any-amount-confirm-account-option">
                          {{ arAccount.AccountName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="display: flex" data-cy="ar-payment-refund-any-amount-confirm-amount-container">
                <div style="flex-basis: 170px" data-cy="ar-payment-refund-any-amount-confirm-amount-label">Refund Amount</div>
                <div style="flex: 1" data-cy="ar-payment-refund-any-amount-confirm-amount-input-container">
                  <mat-form-field style="width:100px;" data-cy="ar-payment-refund-any-amount-confirm-amount-field">
                    <input matInput
                      [ngModel]="this.refundAmount | currency:'USD':'symbol'"
                      (change)="saveCurrencyField($event);"
                      autocomplete="off"
                      data-cy="ar-payment-refund-any-amount-confirm-amount-input">
                    </mat-form-field>
                  </div>
                </div>
                <div style="display: flex" data-cy="ar-payment-refund-any-amount-confirm-comment-container">
                  <div style="flex-basis: 170px" data-cy="ar-payment-refund-any-amount-confirm-comment-label">Comment/Reason</div>
                  <div style="flex: 1" data-cy="ar-payment-refund-any-amount-confirm-comment-input-container">
                    <mat-form-field style="width:100%;" data-cy="ar-payment-refund-any-amount-confirm-comment-field">
                      <input matInput
                        [(ngModel)]="this.refundComment"
                        autocomplete="off"
                        data-cy="ar-payment-refund-any-amount-confirm-comment-input">
                      </mat-form-field>
                    </div>
                  </div>
                  <br>
                    <div data-cy="ar-payment-refund-any-amount-confirm-method-header"><b>Method</b></div>
                    <mat-radio-group aria-label="Select an option"
                      class="refund-method-radio-group"
                      (change)="changeRefundMethod($event)"
                      [(ngModel)]="activeRefundMethod"
                      data-cy="ar-payment-refund-any-amount-confirm-method-group">
                      <mat-radio-button class="insurance-status-option" value="none" data-cy="ar-payment-refund-any-amount-confirm-method-none">None</mat-radio-button>
                      <mat-radio-button class="insurance-status-option" value="cc" data-cy="ar-payment-refund-any-amount-confirm-method-cc">Credit Card</mat-radio-button>
                      <mat-radio-button class="insurance-status-option" value="check" data-cy="ar-payment-refund-any-amount-confirm-method-check">Check</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div style="flex: 2; overflow-y: auto; height: 680px;" data-cy="ar-payment-refund-any-amount-confirm-payments-container">
                    <!--            <div [ngClass]="this.refundFullAmount ? 'tableHeightTall' : 'tableHeightShort'">-->
                    <tdo-table [dataSource]="payments"
                      [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="true"
                      [searchPredicate]="searchPredicate" [footerData]="" (rowSelected)="onRowSelected($event)"
                      data-cy="ar-payment-refund-any-amount-confirm-payments-table">
                      <tdo-table-column displayName="Post Date" propertyName="PaymentTransactionDate" isSortable="true" [rowTemplate]="post" data-cy="ar-payment-refund-any-amount-confirm-col-date">
                        <ng-template #post let-row>
                          @if (row.model.PaymentTransactionDate) {
                            <div data-cy="ar-payment-refund-any-amount-confirm-date">{{ row.model.PaymentTransactionDate | date }}</div>
                          }
                        </ng-template>
                      </tdo-table-column>
                      <tdo-table-column displayName="Practice/Location" propertyName="Description" isSortable="true" [rowTemplate]="practice" data-cy="ar-payment-refund-any-amount-confirm-col-practice">
                        <ng-template #practice let-row>
                          @if (row.model.Practice) {
                            <div data-cy="ar-payment-refund-any-amount-confirm-practice">{{ row.model.Practice + '/' + row.model.Location }}</div>
                          }
                        </ng-template>
                      </tdo-table-column>
                      <tdo-table-column displayName="Account" propertyName="AccountName" [rowTemplate]="account" data-cy="ar-payment-refund-any-amount-confirm-col-account">
                        <ng-template #account let-row>
                          @if (row.model.AccountName) {
                            <div data-cy="ar-payment-refund-any-amount-confirm-account">{{ row.model.AccountName}}</div>
                          }
                        </ng-template>
                      </tdo-table-column>
                      <tdo-table-column displayName="Amount" propertyName="PaymentAmount" [rowTemplate]="amount" data-cy="ar-payment-refund-any-amount-confirm-col-amount">
                        <ng-template #amount let-row>
                          @if (row.model.PaymentAmount) {
                            <div data-cy="ar-payment-refund-any-amount-confirm-amount">{{ row.model.PaymentAmount | currency }}</div>
                          }
                        </ng-template>
                      </tdo-table-column>
                    </tdo-table>
                  <!--            </div>-->
                </div>
              </div>
            </div>
          }

        </div>

        <!--  FOOTER-->
        <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="ar-payment-refund-any-amount-confirm-footer">
          <div style="flex: 1; margin-right: 6px;" data-cy="ar-payment-refund-any-amount-confirm-footer-spacer"></div>
          <button [disabled]="refundButtonDisabled()" (click)="refundClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-payment-refund-any-amount-confirm-refund-btn">Refund</button>
          <button (click)="cancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-payment-refund-any-amount-confirm-cancel-btn">Cancel</button>
        </div>
      </div>
    </div>

